export const regexes = {
  emailRegex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
};
